import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var MenuIcon = function () {
    return (_jsx("svg", { width: '39', height: '39', viewBox: '0 0 39 39', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M13 27.625H30.875M8.125 19.5H30.875M17.875 11.375H30.875', stroke: '#1B1A27', strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round' }) }));
};
